var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[_c('bee-handy-table',{attrs:{"headers":_vm.headers,"items":_vm.underLimitMaterials,"dense":"","zebra":"","pagination-on-scroll":"","height":_vm.$vuetify.breakpoint.height - 130,"fixed-header":"","data-table-props":{
				showExpand: true,
                itemKey: 'employeeId',
                disableSort: true
			},"loading":_vm.loading,"shown-rows-text":_vm.$t('shown-rows')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }